export function prepareGetHeaders(getExportRequestHeaders) {
    return function () {
        return getExportRequestHeaders();
    };
}
//# sourceMappingURL=utils.js.map